import React, { useState } from 'react';
import '../App.css';

function SignIn() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [isRegister, setIsRegister] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`${isRegister ? 'Register' : 'Sign In'} submitted!`);
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2 className="auth-title">{isRegister ? 'Register' : 'Sign In'}</h2>
        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button className="auth-btn" type="submit">{isRegister ? 'Register' : 'Sign In'}</button>
        </form>
        <div className="auth-switch">
          {isRegister ? (
            <>
              Already have an account?{' '}
              <button onClick={() => setIsRegister(false)} className="auth-link">Sign In</button>
            </>
          ) : (
            <>
              New user?{' '}
              <button onClick={() => setIsRegister(true)} className="auth-link">Register</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SignIn;